import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    trades: null,
    pendingTrades: null,
    requisitions: null,
    sales: null,
    expenses: null,
    users: null,
    farmers: null,
    storage: null,
    logistics: null,
    supplyTrades: null,
    companyAssets: null,
    deliveries: null,
    logisticsExpenses: null,
    hubs: null,
    hubSales: null,
    currentHub: null,
    hubInventory: null,
    hubDeliveries: null,
    externalDeliveries: null,
    onlineDeliveries: null,
    deliveryRoutes: null,
    routePlans: null,
};

export const app = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setTrades: (state, { payload }) => {
            state.trades = payload;
        },
        setPendingTrades: (state, { payload }) => {
            state.pendingTrades = payload;
        },
        setRequisitions: (state, { payload }) => {
            state.requisitions = payload;
        },
        setSales: (state, { payload }) => {
            state.sales = payload;
        },
        setExpenses: (state, { payload }) => {
            state.expenses = payload;
        },
        setUsers: (state, { payload }) => {
            state.users = payload;
        },
        setFarmers: (state, { payload }) => {
            state.farmers = payload;
        },
        setStorage: (state, { payload }) => {
            state.storage = payload;
        },
        setLogistics: (state, { payload }) => {
            state.logistics = payload;
        },
        setSupplyTrades: (state, { payload }) => {
            state.supplyTrades = payload;
        },
        setCompanyAssets: (state, { payload }) => {
            state.companyAssets = payload;
        },
        setDeliveries: (state, { payload }) => {
            state.deliveries = payload;
        },
        setLogisticsExpenses: (state, { payload }) => {
            state.logisticsExpenses = payload;
        },
        setHubs: (state, { payload }) => {
            state.hubs = payload;
        },
        setHubSales: (state, { payload }) => {
            state.hubSales = payload;
        },
        setCurrentHub: (state, { payload }) => {
            state.currentHub = payload;
        },
        setHubInventory: (state, { payload }) => {
            state.hubInventory = payload;
        },
        setHubDeliveries: (state, { payload }) => {
            state.hubDeliveries = payload;
        },
        setDeliveryRoutes: (state, { payload }) => {
            state.deliveryRoutes = payload;
        },
        setExternalDeliveries: (state, { payload }) => {
            state.externalDeliveries = payload;
        },
        setOnlineDeliveries: (state, { payload }) => {
            state.onlineDeliveries = payload;
        },
        setRoutePlans: (state, {payload}) => {
            state.routePlans = payload;
        },
    },
});

export const {
    setTrades,
    setRequisitions,
    setSales,
    setExpenses,
    setUsers,
    setFarmers,
    setStorage,
    setLogistics,
    setSupplyTrades,
    setCompanyAssets,
    setDeliveries,
    setLogisticsExpenses,
    setHubs,
    setHubSales,
    setCurrentHub,
    setHubInventory,
    setPendingTrades,
    setHubDeliveries,
    setDeliveryRoutes,
    setExternalDeliveries,
    setOnlineDeliveries,
    setRoutePlans,
} = app.actions;

export default app.reducer;
